import React from "react";

import CssBaseline from "@busbud/design-system-components/dist/CssBaseline";
import Layout from "@busbud/design-system-components/dist/Layout";
import LayoutSection from "@busbud/design-system-components/dist/Layout/LayoutSection";
import Stack from "@busbud/design-system-components/dist/Stack";

import type { Page } from "../account-navigation";

import { useStyles } from "./account-layout.styles";
import { BelowNavigationSection } from "./below-navigation-section";
import { DrawerManager } from "../../../../components/drawers";
import { FunnelFooter } from "../../../../components/footer";
import { ModalManager } from "../../../../components/modals";
import { AccountNavigation } from "../account-navigation";
import { ProfileBalance } from "../profile-balance";

interface Props {
  current_page: Page;
  BelowNavigation?: React.ReactNode;
  children: React.ReactNode;
}

export const AccountLayout: React.FC<Props> = ({ current_page, children }) => {
  const { classes } = useStyles();

  return (
    <>
      <CssBaseline />
      <Layout
        className={classes.layoutRoot}
        component="main"
        id="main" // Used as target for `SkipLink` in `renderRedesignedHeader`
        tabIndex={-1} // Makes it focusable when we navigate to it by clicking a skip link
      >
        <LayoutSection>
          <Stack direction={{ xs: "column", md: "row" }}>
            <div className={classes.navigation}>
              <AccountNavigation current_page={current_page} />
              <BelowNavigationSection>
                <ProfileBalance />
              </BelowNavigationSection>
            </div>
            <div className={classes.content}>{children}</div>
          </Stack>
        </LayoutSection>
      </Layout>
      <FunnelFooter />
      <DrawerManager />
      <ModalManager />
    </>
  );
};
